"use client";

import React, { useRef } from "react";
import CustomInput from "@/components/ui/customInput";
import { Button } from "@/components/ui/button";

import { useEffect } from "react";
import { useContactUsMutation } from "@/redux/apiSlices/formApi";
import { isValid } from "@/lib/utils";
import { useToast } from "@/components/ui/use-toast";
import { Controller, useForm } from "react-hook-form";
import { useNewsletterMutation } from "@/redux/apiSlices/authApis";
import FeedBack from "../Feedback";

const Newsletter = ({ message = "No Results Found!" }) => {
  const { toast } = useToast();
 const formRef = useRef(null); 
 
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  
  const [
    newsletter,
    { data, isSuccess, isLoading: isNewsletterLoading, isError, error: errMsg },
  ] = useNewsletterMutation();

  const isLoading = isNewsletterLoading;
  useEffect(() => {
    if (isSuccess) {
      if (data?.success) {
        toast({
          title: data?.message,
        });
      }
    }
    if (isError) {
      toast({
        variant: "destructive",
        title: errMsg?.data?.message,
      });
    }
  }, [isSuccess, isError]);
  
 const [contactUs, { dataForm, isFormSuccess, isLoading: isUserLoading, isFormError, error: errFormMsg }] = useContactUsMutation();
  useEffect(() => {
    if (isFormSuccess) {
      if (dataForm?.success) {
        toast({ title: "The email has been sent successfully." })
      }
    }
    if (isFormError) {
      toast({
        title: errFormMsg?.data?.msg,
      });
    }
  }, [isFormSuccess, isFormError]);
  const onSubmit = async (data) => {
    if (!formRef.current) return;

    try {
      newsletter(data);
      reset(); // ✅ Reset form fields after successful submission
    } catch (error) {
      toast({
        title: error,
      });
    }
  };

  return (
    <div className="  w-[363px] mxl:w-full  mxl:row-start-2 mxl:col-start-5 mxl:col-end-7">
            <h2 className=" text-[20px] smd:text-[14px] smd:font-medium leading-[34px] font-bold uppercase">
              Sign up now
            </h2>

            <p className=" smd:text-[13px] mb-4 text-[14px] leading-[23px]">
              Stay in the loop, with exclusive offers and product previews.
            </p>
            <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                  <div className="grid">
                  <input type="hidden" name="subject" value={'Newsletter'}  />                  
                <Controller
                    name="name"
                    control={control}
                    rules={{
                      required: true,
                      validate: (value) => value.trim() !== "" || "Only spaces are not allowed",
                    }}
                    render={({ field }) => (
                      <CustomInput
                        labelClassName="bg-white"
                        label="Name*"
                        maxLength={25}
                        isInvalid={isValid("name", errors)}
                        errorMessage="Please enter name"
                        {...field}
                      />
                    )}
                  />              
                  </div>
                  <div className="grid">
                    <Controller
                      name="email"
                      control={control}
                      rules={{
                        required: "Please enter email ",
                        pattern: {
                          value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                          message: "Please enter valid email",
                        },
                      }}
                      render={({ field }) => (
                        <CustomInput
                          labelClassName="bg-white"
                          label="Email Address"
                          maxLength={1000}
                          isInvalid={isValid("email", errors)}
                          errorMessage="Please enter valid email"
                          {...field}
                        />
                      )}
                    />
                  </div>
            
                  <div className=" flex items-center justify-center mt-[5px] mb-[13px]">
                    <Button
                      type="submit"
                      className=" text-[14px] w-full mzx-w-[300px] bg-blue2 text-white h-[38px] rounded-[8px]"
                      disabled={isLoading}
                    >
                      Sign Up
                    </Button>
                  </div>
                </form>            
            <FeedBack />
          </div>
  );
};

export default Newsletter;